import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';

import DisplayText from '../text/DisplayText';
import { getOTProfiles } from '../../settings/state/settings.actions';

export default function OtProfileSelect({
  value,
  onChange,
  placeholder = 'Company default',
  style,
  allowClear = true,
  displayOnly = false,
}) {
  const dispatch = useDispatch();
  const otProfiles = useSelector((state) => state.settings.otProfiles) || [];

  useEffect(() => {
    if (otProfiles.length === 0) {
      dispatch(getOTProfiles());
    }
  }, [otProfiles]);

  if (displayOnly) {
    const label = otProfiles.find((p) => p.id === value)?.name || placeholder;
    return <DisplayText title={label} />;
  }

  const companyProfile = otProfiles.find((p) => p.isCompanyProfile);
  const options = otProfiles.map((p) => ({ label: p.name, value: p.id }));

  if (companyProfile && !options.some((o) => o.value === value)) {
    onChange(companyProfile.id);
  }

  return (
    <Select
      allowClear={allowClear}
      placeholder={placeholder}
      style={style}
      value={value || undefined}
      onChange={onChange}
      options={options}
    />
  );
}

OtProfileSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.shape({}),
  allowClear: PropTypes.bool,
  displayOnly: PropTypes.bool,
};

OtProfileSelect.defaultProps = {
  value: undefined,
  placeholder: 'Company Default',
  style: {},
  allowClear: true,
  displayOnly: false,
};
